export enum BeneficiaryType {
  SPOUSE = 'SPOUSE',
  SPOUSE_AND_CHILDREN = 'SPOUSE_AND_CHILDREN',
  CHILDREN = 'CHILDREN',
  NEXT_OF_KIN = 'NEXT_OF_KIN',
  DEATH_ESTATE = 'DEATH_ESTATE',
  NAMED_BENEFICIARY = 'NAMED_BENEFICIARY',
}

export enum NamedBeneficiaryType {
  PERSON = 'PERSON',
  COMPANY_OR_COMMUNITY = 'COMPANY_OR_COMMUNITY',
}

export interface NamedBeneficiary {
  namedBeneficiaryType: NamedBeneficiaryType;
  percentage: number | undefined;
}

export interface NamedPersonBeneficiary extends NamedBeneficiary {
  ssn: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  maritalRightsExcluded?: boolean;
}

export interface NamedCompanyOrCommunityBeneficiary extends NamedBeneficiary {
  businessId: string | undefined;
  name: string | undefined;
}
